import { RemoveButton } from "../../../../components/form-controls/button/remove-button/remove-button.component";
import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";
import { RemoveContentButtonProps } from "./remove-content-button.props";

export const RemoveContentButton = withShowIf(
  ({ buttonText, onClick }: RemoveContentButtonProps) => {
    return <RemoveButton onClick={onClick}>{buttonText}</RemoveButton>;
  }
);
